function formatCity (city) {
  return {
    type: 'City',
    text: city.attributes.full_name,
    id: city.id
  }
}

function formatSector (sector) {
  return {
    type: 'Sector',
    text: sector.attributes.name,
    id: sector.id
  }
}

function formatCities (cities) {
  return cities.map(city => formatCity(city))
}

function formatSectors (sectors) {
  return sectors.map(sector => formatSector(sector))
}

function formatLocations ({ cities, sectors }) {
  return [
    {
      label: 'Villes',
      values: formatCities(cities)
    },
    {
      label: 'Secteurs',
      values: formatSectors(sectors)
    }
  ]
}

export {
  formatCity,
  formatSector,
  formatCities,
  formatSectors,
  formatLocations
}
